import type { ReactNode } from 'react';
import { Children, Fragment } from 'react';

import { Box, Card } from '@jane/shared/reefer';

import { SpecialDetailStatusBundleProgress } from './specialDetailStatusBundleProgress/specialDetailStatusBundleProgress';
import { SpecialDetailStatusFooter } from './specialDetailStatusFooter/specialDetailStatusFooter';
import { SpecialDetailStatusHeader } from './specialDetailStatusHeader/specialDetailStatusHeader';
import { SpecialDetailStatusSticky } from './specialDetailStatusSticky/specialDetailStatusSticky';

const SpecialDetailStatusCard = ({ children }: { children: ReactNode }) => {
  const childrenArray = Children.toArray(children);

  return (
    <Card width="100%" border="transparent-black-five">
      {childrenArray.map((child, index) => (
        <Fragment key={index}>
          {child}
          {index < childrenArray.length - 1 && (
            <Box height={1} width="100%" background="grays-light" />
          )}
        </Fragment>
      ))}
    </Card>
  );
};

export const SpecialDetailStatus = Object.assign(SpecialDetailStatusCard, {
  Header: SpecialDetailStatusHeader,
  BundleProgress: SpecialDetailStatusBundleProgress,
  Footer: SpecialDetailStatusFooter,
  Sticky: SpecialDetailStatusSticky,
});
